import * as React from 'react';

import { sections } from 'components/lexemes';
import { CdnImagePath } from 'lib/cdn-image-path';

import { PageSectionTwoColumnsImageLeftColumn } from 'components/page/sections/page-section-two-columns-image-left-column';

export const TabNineContainer: React.FC = () => {
  const props = {
    title: sections.tabNineSection.tab.title(),
    subTitle: sections.tabNineSection.tab.content(),
    image: {
      src: `${CdnImagePath}/assets/tab-09/tab-09-01.jpg`,
      objectPosition: '50% 33%',
      inlinePosition: 'start',
    },
  };

  return <PageSectionTwoColumnsImageLeftColumn {...props} />;
};
